import {Box, Button, IconButton} from "@material-ui/core";
import {ArrowRightAlt, Code, Email} from "@material-ui/icons";
import React from "react";

export default function GoButtons(props: {
    siteUrl?: string;
    codeUrl?: string;
    email?: string;
}) {
    return (
        <Box marginTop={2} display='flex' flexDirection='row' alignItems='stretch' justifyContent='flex-end'>
            {props.codeUrl && (
                <IconButton
                    aria-label='Code'
                    href={props.codeUrl}
                ><Code/></IconButton>
            )}
            {props.email && (
                <IconButton
                    aria-label='Visit'
                    href={`mailto:${props.email}`}
                ><Email/></IconButton>
            )}
            {props.siteUrl && (
                <IconButton
                    aria-label='Visit'
                    href={props.siteUrl}
                ><ArrowRightAlt/></IconButton>
            )}
        </Box>
    );
}